import getShouldUseStandardGetStats from './shouldUseStandardGetStats';

const shouldUseStandardGetStats = getShouldUseStandardGetStats();

// getRtcStatsReport is only supported on browsers that support the standard getStats API.
export default shouldUseStandardGetStats;
